
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "../packages/sso/src/store/index";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../packages/sso/src/scss/element-variables.scss";
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'

Vue.use(ElementUI);
/* 这是全局样式 */
Vue.config.productionTip = false;
//設置主題色
import Theme from "theme-vue";
const Th = new Theme();
Vue.prototype.Th = Th;
console.log(router,'routerrouterrouter')
// 设置语言
import VueI18n from "vue-i18n";
import ssoConfig from "../packages/sso/index.js";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale:  window.location.href.indexOf('language=en')>-1?'en':'zh-HK', // 语言标识
  messages: {
    "zh-HK": {
      ...ssoConfig.hk.hk,
      ...zhLocale
    },
    en: { ...ssoConfig.en.en,...enLocale },
  },
});
ElementLocale.i18n((key, value) => i18n.t(key, value))
/*引入配置列表*/
Vue.prototype.$apis = ssoConfig.api;
Vue.prototype.$loadScript = ssoConfig.loadScript;
import Dator from "../packages/sso/src/rules/censor.js";
Vue.prototype.$Dator = Dator;

import Cookies from "vue-cookies";
Vue.prototype.$Cookies = Cookies;
Vue.mixin({
  data() {
    return {
      locale_lang:window.location.href.indexOf('language=en')>-1?'en':'zh-HK',// 全局语言标识
    };
  },
  methods: {
    language(name) {
      return this.$t(name);
    },
    languageTC(name,num) {
      return this.$tc(name,num);
    },
    defalutToast(message, type) {
      if (type == "success") {
        this.$message({
          message: message,
          type: "success",
        });
      } else {
        this.$message.error(message);
      }
    },
    goToPage(data) {
      let query = "?language="+(window.location.href.indexOf('language=en')>-1?'en':'zh-HK');
      let index = 0;
      for (const key in data.query) {
        // if (index == 0) {
        //   query += "?" + key + "=" + data.query[key];
        // } else {
          query += "&" + key + "=" + data.query[key];
        // }
        index++;
      }
      this.$router.push(data.url + query);
    },
    replacePage(data) {
      let query = "";
      let index = 0;
      for (const key in data.query) {
        if (index == 0) {
          query += "?" + key + "=" + data.query[key];
        } else {
          query += "&" + key + "=" + data.query[key];
        }
        index++;
      }
      window.location.replace(data.url + query);
    },
    openWindow(data) {
      let query = "";
      let index = 0;
      for (const key in data.query) {
        if (index == 0) {
          query += "?" + key + "=" + data.query[key];
        } else {
          query += "&" + key + "=" + data.query[key];
        }
        index++;
      }
      window.open(data.url + query, "_blank");
    },
    //登錄時賬號服務關閉了提示
    openServiceTips(err, textObj) {
      let data = {
        tips:  this.language('err.tipsText3'),
        tilte:  this.language('ui.tipsTitle'),
        confirm: this.language('err.tipsText5'),
        cancel: this.language('form.cancelBtn'),
        type: "warning",
      };
      if (textObj) {
        data = textObj;
      }
      return new Promise((resolve, reject) => {
        if (err.code != 40103) {
          this.defalutToast(err.message);
          reject();
        } else if (err.code == 40103) {
          this.$confirm(data.tips, data.tilte, {
            confirmButtonText: data.confirm,
            cancelButtonText: data.cancel,
            type: data.type,
          })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        }
      });
    },
    //賬號401時處理邏輯
    user401(err) {
      if (err && err.code == 401) {
        // this.goToPage({ url: "login", query: {} });
        this.replacePage({
          url: this.$urlData.logoutURL,
          query: {},
        });
      }
    },
  },
  mounted() {},
});
Vue.prototype.$urlData = {};
//白名单
let redirectURL=[
  // 正式
  "https://www.mybookone.com.hk/webapp/#/web/login/sso",
  "https://www.sunyabookclub.com.hk/webapp/#/web/login/sso",

  //灰度
  "https://nr1dev.mybookone.com.hk/webapp/#/web/login/sso",
  "https://dev-www.sunyabookclub.com.hk/webapp/#/web/login/sso",
]

let logoutURL=[
  // 正式
  "https://www.mybookone.com.hk/webapp/#/web/logout/sso",
  "https://www.sunyabookclub.com.hk/webapp/#/web/logout/sso",

    //灰度
  "https://nr1dev.mybookone.com.hk/webapp/#/web/logout/sso",
  "https://dev-www.sunyabookclub.com.hk/webapp/#/web/logout/sso",
]



router.beforeEach((to, from, next) => {
  //先從url獲取沒有再從緩存獲取
  if (to.query && to.query.appid) {
    Vue.prototype.$urlData = to.query;

    if(redirectURL.indexOf(to.query.redirectURL)==-1){
       Vue.prototype.$urlData.redirectURL=process.env.VUE_APP_memeberHttps
    }
    if(logoutURL.indexOf(to.query.logoutURL)==-1){
       Vue.prototype.$urlData.logoutURL=process.env.VUE_APP_memeberHttps
    }

    localStorage.setItem("app", JSON.stringify(Vue.prototype.$urlData));
  } else {
    let app = localStorage.getItem("app");
    if (app) {
      app = JSON.parse(app);
      if(redirectURL.indexOf(app.redirectURL)==-1){
        app.redirectURL=process.env.VUE_APP_memeberHttps
      }
      if(logoutURL.indexOf(app.logoutURL)==-1){
        app.logoutURL=process.env.VUE_APP_memeberHttps
      }
      Vue.prototype.$urlData = app;
    } else {
      window.location.replace(process.env.VUE_APP_memeberHttps);
    }
  }
  next();
});
new Vue({
  router,
  store,
  i18n,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
